module.exports = __webpack_public_path__ + "resources/img/pc_banner6.27667c66b4f1d6403eb6484ae2f09ea1.png";